import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { message, Space } from "antd";
import { useSelector } from "react-redux";
import InterfaceTable from "../../Table/InterfaceTable";
import { getImpactsSelector } from "../Infrastructure/Projects.reducer";
import { getImpactsByProject } from "../Application/Projects.business";
import { DeleteIcon, ModalDeleteConfirm } from "../../Utils/UI/Text";
import { deleteImpact } from "../Application/Projects.business";
import DoubleClickEditLabel from "../../DoubleClickEditLabel/UI/DoubleClickEditLabel";

const ProjectImpactsTable = () => {
  const { id } = useParams();
  const impacts = useSelector(getImpactsSelector);

  useEffect(() => {
    const fetchImpacts = async () => {
      try {
        await getImpactsByProject(id);
      } catch (error) {
        console.error("Error:", error);
        message.error("Error al cargar impacts del proyecto");
      }
    };
    fetchImpacts();
  }, [id]);

  const handleDelete = async (id, impactId) => {
    console.log("Intentando eliminar:", impactId);

    try {
      ModalDeleteConfirm({
        title: "¿Está seguro de eliminar este impact?",
        messageOnOk: "Se eliminó el impact correctamente.",
        onConfirm: () => deleteImpact(id, impactId),
        onCancel: () => {},
      });
    } catch (error) {
      message.error("Se produjo un error, vuelva a intentarlo.");
    }
  };

  const columns = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Subtítulo",
      dataIndex: "subtitle",
      key: "subtitle",
      render: (text, record) => {
        console.log("RECORD:", record.id);
        return (
          <DoubleClickEditLabel
            str={text}
            labelKey="subtitle"
            type="impact"
            id={id}
            id_resource={record.id || record._id || ""}
            onRefresh={() => getImpactsByProject(id)}
            confirmBeforeEdit={true}
          />
        );
      },
    },
    {
      title: "Acciones",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <Space size="middle">
          <DeleteIcon
            TooltipDelete="Eliminar un Impact"
            onClick={() => handleDelete(id, record.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <InterfaceTable
      rowKey="id"
      data={impacts?.resources || []}
      columns={columns}
    />
  );
};

export default ProjectImpactsTable;
